<div class="flex flex-col h-full">

    <!-- En-tête du tableau -->
    <div class="flex items-center border border-gray-300 rounded-t-md bg-gray-50 px-4 py-3">
        <span class="flex-1 text-center font-semibold text-base">{{ 'vues.ipad.engagements.headerTitle' | translate }}</span>
        <span class="w-10 flex justify-center">
            @if (allChecked()) {
            <i class="fas fa-check text-green-500 text-lg"></i>
            }
        </span>
    </div>

    <!-- Liste des items (accordéon) -->
    <div class="border-x border-b border-gray-300 rounded-b-md divide-y divide-gray-200 overflow-y-auto max-h-[500px]">
        @for (item of items; track item.id) {
        <!-- Ligne titre (cliquable) -->
        <div>
            <div class="flex items-center cursor-pointer px-4 py-3 hover:bg-gray-50"
                (click)="toggleExpand(item.id)">
                <span class="mr-2">
                    @if (isExpanded(item.id)) {
                    <i class="fas fa-chevron-down text-sm text-red-400"></i>
                    } @else {
                    <i class="fas fa-chevron-right text-sm text-red-400"></i>
                    }
                </span>
                <span class="flex-1 text-red-400 font-medium" [innerHTML]="getTitle(item)"></span>
                <!-- Checkbox individuel -->
                <input
                    type="checkbox"
                    class="w-5 h-5 rounded border-gray-400 text-blue-600 focus:ring-blue-500 cursor-pointer"
                    [checked]="isChecked(item.id)"
                    (click)="$event.stopPropagation()"
                    (change)="toggleCheck(item.id)" />
            </div>

            <!-- Contenu HTML (expandé) -->
            @if (isExpanded(item.id)) {
            <div class="px-6 py-4 bg-white border-t border-gray-100">
                <div [innerHTML]="getContent(item) | safeHtml"></div>
            </div>
            }
        </div>
        }
    </div>

    <!-- Case d'acceptation globale -->
    <div class="flex items-start space-x-3 mt-6 px-2">
        <label class="flex items-start cursor-pointer">
            <input
                type="checkbox" [disabled]="!allChecked()"
                class="w-5 h-5 mt-0.5 rounded border-gray-400 text-blue-600 focus:ring-blue-500 cursor-pointer"
                [checked]="allAccepted()"
                (change)="onAllAcceptedChange($any($event.target).checked)" />
            <span class="text-gray-700 text-sm leading-snug ml-2">{{ 'vues.ipad.engagements.acceptanceText' | translate }}</span>
        </label>
    </div>
    <!-- Signature -->
    @if (showSignature && allAccepted()) {
    <div class="mt-4">
        <app-signature-pad
            [height]="200"
            [placeholder]="'vues.ipad.signaturePlaceHolder' | translate"
            (signatureChange)="onSignatureChange($event)">
        </app-signature-pad>
    </div>
    }

</div>